import { render, staticRenderFns } from "./IBackupSalesforceStatusDropdown.vue?vue&type=template&id=5bb5fff2&"
import script from "./IBackupSalesforceStatusDropdown.vue?vue&type=script&lang=js&"
export * from "./IBackupSalesforceStatusDropdown.vue?vue&type=script&lang=js&"
import style0 from "./IBackupSalesforceStatusDropdown.vue?vue&type=style&index=0&id=5bb5fff2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports